import { render, staticRenderFns } from "./AppUpdate.vue?vue&type=template&id=19d0f9c8"
import script from "./AppUpdate.vue?vue&type=script&lang=js"
export * from "./AppUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports